import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { FieldSet } from "../../fieldset";
import { Merchant } from "../../merchant";
import { CountryList, MerchantField, SalesChannel } from "../../types";

const applicableCountries: CountryList[] = [
  "Australia",
  "New Zealand",
  "United States",
  "United Kingdom",
];

const defaultValue: SalesChannel = "Online Only";
export class SalesChannelField extends Field<SalesChannel> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<SalesChannel>> = {}
  ) {
    super(
      model,
      {
        applicable: true,
        dataType: "string",
        pickList: ["Online Only", "In-store Only", "Online and In-store"],
        propertyName: "salesChannel",
        required: true,
        uiFieldType: "Select",
        ...opts,
      },
      fieldSet
    );
  }

  get shown(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return (
      registeredCountry !== undefined &&
      applicableCountries.includes(registeredCountry)
    );
  }

  get value(): SalesChannel | undefined {
    if (!this._value) {
      return defaultValue;
    }
    return this._value;
  }

  set value(value: SalesChannel | undefined) {
    this._value = value;
  }

  _validate(): void {
    const contactlessPayment = this._model.storeDetails.contactlessPayment
      .value;
    if (hasInstoreChannel(this.value)) {
      if (contactlessPayment === "No") {
        throw new FieldError(
          this,
          `In-store service is only available for stores with contactless payment. Please select "Online Only" if you don't have contactless payment for your stores.`,
          "FieldMismatch"
        );
      }
    }
  }
}
